import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import AuthCallback from './components/AuthCallback';
import Dashboard from './components/Dashboard';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import { CloudProvider } from './context/CloudContext';
import { FeatureProvider } from './context/FeatureContext';
import { ConfigProvider, theme } from 'antd';
import './App.css';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
}

function AntConfigWrapper({ children }: { children: React.ReactNode }) {
  const { isDark } = useTheme();
  
  return (
    <ConfigProvider
      theme={{
        algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
      }}
    >
      {children}
    </ConfigProvider>
  );
}

function App() {
  return (
    <ThemeProvider>
      <CloudProvider>
        <AuthProvider>
          <FeatureProvider>
            <Router>
            <div className="App">
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/*" element={
                  <ProtectedRoute>
                    <AntConfigWrapper>
                      <Dashboard />
                    </AntConfigWrapper>
                  </ProtectedRoute>
                } />
              </Routes>
            </div>
          </Router>
          </FeatureProvider>
        </AuthProvider>
      </CloudProvider>
    </ThemeProvider>
  );
}

export default App;
